<div>
    <span [ngStyle]="inputStyles">{{ formattedDate }}</span>
</div>